import { UserIVandGetScoreResponse } from "../../proto/UserIVandGetScore_pb";

export const SET_IVAND_SCORE = "SET_IVAND_SCORE";

export type IVandType = UserIVandGetScoreResponse.AsObject | undefined;

export type IVandStateType = {
  score: IVandType;
};

export type SetIVandActionType = {
  type: typeof SET_IVAND_SCORE;
  payload: IVandType;
};

export type IVandActionTypes = SetIVandActionType;
